
<!-- <p-toast></p-toast> -->
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card dashboardTable">
            <p-toolbar styleClass="mb-4" reflow="true">
                <ng-template pTemplate="left"></ng-template>
                <ng-template pTemplate="right">
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                                  class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>
                   </p-toolbar>
            <!-- <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                        class="p-button-success"></button>
                    <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button>
                </ng-template>
                <ng-template pTemplate="right">
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload>
                    <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                        class="p-button-help"></button>
                    <p-menu #menu [popup]="true" [model]="items"></p-menu>
                </ng-template>

            </p-toolbar> -->

            <p-table #appVerificationTable [value]="appVerificationModel" [rows]="10" [paginator]="true"
                [globalFilterFields]="['appID', 'FarmerName', 'village', 'block', 'district', 'AgeOfApplication', 'ProgrammeName', 'LandDetail', 'Total_Area','PendingCompletedDays', 'Status_Ar', 'status','DeptRemarks', 'EstimationStatus', 'FinYear']"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'MI_ESTIMATION_HEADER'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input style="width: 100% ;" pInputText type="text"
                                (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" class="tableHeader">
                    <tr>
                        <!-- <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th> -->
                        <th pSortableColumn="appID">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                            <p-sortIcon field="appID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                            <p-sortIcon field="village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="district">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AgeOfApplication">{{'AGE_OF_APPLICATION'| translate}}
                            <p-columnFilter type="text" field="AgeOfApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="AgeOfApplication"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                            <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                            <p-sortIcon field="ProgrammeName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="LandDetail">{{'LAND_DETAIL'| translate}}
                            <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
                            <p-sortIcon field="LandDetail"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
                            <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS'| translate}}
                            <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status_Ar"></p-sortIcon>
                        </th>
                        <th pSortableColumn="status">{{'STATUS'| translate}}
                            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th pSortableColumn="DeptRemarks">{{'DEPT_REMARKS'| translate}}
                            <p-columnFilter type="text" field="DeptRemarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="DeptRemarks"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>

                        <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}} </th>

                        <!-- <th pSortableColumn="">{{'ESTIMATION_ACTION'| translate}}</th> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <!-- <tr [ngStyle]="{border: '2px solid black' ,'border-color': product.EstimationStatus==1  ? '#66ff66' : '#ffffff'}"> -->
                        <!-- <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td> -->
                        <td>{{product.appID}}</td>
                        <!-- <td>{{product.remarks}}</td> -->
                        <td>{{product.FarmerName | uppercase}}</td>
                        <td>{{product.village}}</td>
                        <td>{{product.block}}</td>
                        <td>{{product.district}}</td>
                        <td>{{product.AgeOfApplication}}</td>
                        <td>{{product.ProgrammeName}}</td>
                        <td>{{product.LandDetail}}</td>
                        <td>{{product.Total_Area}}</td>
                        <td>{{product.PendingCompletedDays}}</td>
                        <td>{{product.Status_Ar}}</td>
                        <td>{{product.status}}</td>
                        <td>{{product.DeptRemarks}}</td>
                        <td>{{product.FinYear}}</td> 
                        <td>
                            <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="printForm(product.appID,product?.Status_Ar,product?.ProgramID)"></button>
                            <!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                (click)="deleteProduct(product)"></button> -->
                        </td>
                        <!-- <td *ngIf="product.EstimationStatus==2">
                            <button pButton pRipple type="button" pTooltip="Add-Estimation" icon="pi pi-plus"
                                class="p-button-rounded p-button-text" (click)="addEstimation(product)"></button>
                        </td>
                        <td *ngIf="product.EstimationStatus==1">
                            <button pButton pRipple type="button" pTooltip="Edit-Estimation"
                                (click)="updateEstimation(product)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                            <button pButton pRipple type="button" pTooltip="Delete-Estimation" icon="pi pi-times"
                                class="p-button-rounded p-button-text p-button-danger"
                                (click)="deleteEstimation(product)"></button>
                        </td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{appVerificationModel ? appVerificationModel.length : 0 }}
                        {{'VER_APP_ADDED'| translate}}
                    </div><br>
                    <div class="flex  justify-content-between flex-column ">
                        <div class="flex">
                            <div
                                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_BY_ONE_DAY'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'ESTIMATED_ON_TIME'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'DELAYED_APPROVED'| translate}}
                        </div>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>


<p-dialog header="{{'CREATE_ESTIMATION'| translate}}" [(visible)]="displayEstimateDialog" [modal]="true"
    [style]="{width: '100%',height:'100%'}" [maximizable]="true" [draggable]="false" [resizable]="false"
    (onHide)="onCloseDialog()">

    <div class="p-fluid p-formgrid grid justify-content-center">
        <div class="field col-6 md:col-4">
            <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeAppId
                    }}</label></label>
        </div>

        <div class="field col-6 md:col-4">
            <label>{{'FARMER_NAME'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{ programmeFarmerName |
                    uppercase}}</label></label>
        </div>
    </div>


    <!-- Content Start-->
    <div class="card dropdown-content" style="margin-bottom: 5px;">
        <!-- <h4>Estimation Detail</h4> -->
        <div class="p-fluid p-formgrid grid">

            <div class="field col-12 md:col-2">
                <label htmlFor="selectCategory">{{'PROGRAMME_NAME'| translate}}</label>
                <div class="grid-item">
                    <input readonly [(ngModel)]="programmeName" pInputText type="text" />
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="selectCategory">{{'SELECT_CATEGORY'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="category" [(ngModel)]="selectedCategory" (onChange)="onSelectCategory()"
                        placeholder="{{'SELECT_A_CATEGORY'| translate}}" optionLabel="categoryName"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="selectComponent">{{'SELECT_COMPONENT'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="component" [(ngModel)]="selectedComponent" (onChange)="onSelectComponent()"
                        placeholder="{{'SELECT_A_COMPONENT'| translate}}" optionLabel="componentName"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="selectedSizePrice">{{'SELECT_SIZE_PRICE'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="sizePrice" [(ngModel)]="selectedSizePrice" (onChange)="onSelectSizePrice()"
                        placeholder="{{'SELECT_SIZE_PRICE'| translate}}" optionLabel="sizeAndPrice"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-2">
                <label htmlFor="enterQuantity">{{'ENTER_QUANTITY'| translate}}</label>
                <!-- <div class="grid-item">
                    <label>Enter Quantity</label>
                </div> -->
                <div class="grid-item">
                    <input type="number" min="1" step="1"
                        onkeypress="return event.charCode >= 48 && event.charCode <= 57" title="Numbers only" pInputText
                        [(ngModel)]="enteredQuantity" required [ngClass]="{ 'ng-invalid ng-dirty': enteredQuantity<1 }">
                    <div class="invalid-feedback">
                        <div *ngIf="enteredQuantity<1">{{'NOTE_ON_INVALID_QUANTITY'| translate}}</div>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-1">
                <!-- Add Button -->
                <label></label>
                <div class="grid-item">
                    <button pButton pRipple type="button" label="{{'ADD'| translate}}" (click)="addTable()"
                        [disabled]="(!tableHide) || selectedSizePrice.cmlVal == 1" style="margin: 5px;"></button>
                </div>
            </div>

            <div *ngIf="selectedSizePrice" class="field col-12 md:col-12">
                <div class="invalid-feedback">
                    <div *ngIf="selectedSizePrice.cmlVal == 1"> {{'CML_VALIDITY_EXP_ON'| translate}}
                        {{selectedSizePrice?.cmlValidity}} {{'FOR'| translate}} {{selectedComponent?.componentName}}.
                        {{'PLEASE_UPLOAD_CML_VALIDTY'| translate}} </div>
                </div>
                <div class="valid-feedback">
                    <div *ngIf="selectedSizePrice.cmlVal == 0">{{'CML_VALIDITY_IS_VALID_UPTO'| translate}}
                        {{selectedSizePrice?.cmlValidity}} {{'FOR'| translate}} {{selectedComponent?.componentName}}.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="tableData.length != 0">
        <!-- Table Start -->
        <div class="card dashboardTable" style="margin: 5px;">
            <!-- <p-table [value]="tableData" [rows]="10" [paginator]="true" [globalFilterFields]="['srNO', 'CatName', 'ComponentName', 'Size', 'Price', 'Quantity', 'Amount', 'GST', 'GSTAmount', 'AmountWithGST']" responsiveLayout="scroll" [(selection)]="tableData"
                [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true"> -->
            <p-table [value]="tableData" [rows]="10" [paginator]="false"
                [globalFilterFields]="['srNO', 'CatName', 'ComponentName', 'Size', 'Price', 'Quantity', 'Amount', 'GST']"
                responsiveLayout="scroll" [(selection)]="tableData" [rowHover]="true" dataKey="id"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="srNO">{{'S_NO'| translate}}
                        </th>
                        <th pSortableColumn="CatName">{{'CATEGORY_NAME'| translate}}
                            <p-columnFilter type="text" field="CatName" display="menu"></p-columnFilter>
                            <p-sortIcon field="CatName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ComponentName">{{'COMPONENT_NAME'| translate}}
                            <p-columnFilter type="text" field="ComponentName" display="menu"></p-columnFilter>
                            <p-sortIcon field="ComponentName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Size">{{'SIZE'| translate}}
                            <p-columnFilter type="text" field="Size" display="menu"></p-columnFilter>
                            <p-sortIcon field="Size"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Price">{{'PRICE'| translate}}
                            <p-columnFilter type="text" field="Price" display="menu"></p-columnFilter>
                            <p-sortIcon field="Price"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Quantity">{{'QUANTITY'| translate}}
                            <p-columnFilter type="text" field="Quantity" display="menu"></p-columnFilter>
                            <p-sortIcon field="Quantity"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Amount">{{'AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Amount"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="GST">GST%
                            <p-columnFilter type="text" field="GST" display="menu"></p-columnFilter>
                            <p-sortIcon field="GST"></p-sortIcon>
                        </th> -->
                        <!-- <th pSortableColumn="GSTAmount">GST Amount
                            <p-columnFilter type="text" field="GSTAmount" display="menu"></p-columnFilter>
                            <p-sortIcon field="GSTAmount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AmountWithGST">Amount with GST
                            <p-columnFilter type="text" field="AmountWithGST" display="menu"></p-columnFilter>
                            <p-sortIcon field="AmountWithGST"></p-sortIcon>
                        </th> -->
                        <th>{{'ACTION'| translate}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>{{rowIndex + 1}}</td>
                        <td>{{product.CatName}}</td>
                        <td>{{product.ComponentName}}</td>
                        <td>{{product.Size}}</td>
                        <td>{{'RS.'| translate}} {{product.Price | number : '1.2-2'}}</td>
                        <td>{{product.Quantity}}</td>
                        <!-- <td>Rs. {{product.Price*product.Quantity | number : '1.2-2'}}</td> -->
                        <td>{{'RS.'| translate}} {{product.Amount | number : '1.2-2'}}</td>
                        <!-- <td>{{product.GST}}%</td> -->
                        <!-- <td>Rs. {{product.Price*product.Quantity + (product.Price*product.Quantity*product.GST)/100 | number : '1.2-2'}}</td> -->
                        <!-- <td>Rs.{{product.GSTAmount | number : '1.2-2'}}</td> -->
                        <!-- <td>Rs. {{(product.Price*product.Quantity*product.GST)/100 | number : '1.2-2'}}</td> -->
                        <!-- <td>Rs. {{product.AmountWithGST | number : '1.2-2'}}</td> -->
                        <td><button pButton pRipple type="button" icon="pi pi-times" (click)="onRowDelete(rowIndex)"
                                class="p-button-rounded p-button-text p-button-danger"></button></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <!-- Table End -->

        <!-- Final Estimation Details Start -->
        <div class="col-12">
            <div class="card estiamtion-header">
                <!-- <h4>Estimation Header Details</h4> -->
                <form [formGroup]="finalEstimationDetails">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-2">
                            <label htmlFor="plantSpacing">{{'PLANT_SPACING'| translate}}</label>
                            <input [readonly]="!showInputfields" formControlName="plantSpacing" pInputText
                                id="plantSpacing" type="number"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.plantSpacing.touched && finalEstimationControls.plantSpacing.errors }" />
                            <div *ngIf="finalEstimationControls.plantSpacing.touched && finalEstimationControls.plantSpacing.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.plantSpacing.errors.required">
                                    {{'ON_INVALID_PLANT_SPACING'| translate}}
                                </div>
                            </div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="rowSpacing">{{'ROW_SPACING'| translate}}</label>
                            <input [readonly]="!showInputfields" formControlName="rowSpacing" pInputText id="rowSpacing"
                                type="number"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.rowSpacing.touched && finalEstimationControls.rowSpacing.errors }" />
                            <div *ngIf="finalEstimationControls.rowSpacing.touched && finalEstimationControls.rowSpacing.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.rowSpacing.errors.required">
                                    {{'ON_INVALID_ROW_SPACING'| translate}}
                                </div>
                            </div>
                        </div>

                        <!-- <div class="field col-12 md:col-2">
                            <label htmlFor="latitude">{{'LATITUDE'| translate}}</label>
                            <input formControlName="latitude" pInputText id="latitude" type="number"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.latitude.touched && finalEstimationControls.latitude.errors }" />
                            <div *ngIf="finalEstimationControls.latitude.touched && finalEstimationControls.latitude.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.latitude.errors.required">{{'LATITUDE_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div> -->

                        <!-- <div class="field col-12 md:col-2">
                            <label htmlFor="longitude">{{'LONGITUDE'| translate}}</label>
                            <input formControlName="longitude" pInputText id="longitude" type="number"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.longitude.touched && finalEstimationControls.longitude.errors }" />
                            <div *ngIf="finalEstimationControls.longitude.touched && finalEstimationControls.longitude.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.longitude.errors.required">{{'LONGITUDE_IS_REQUIRED'| translate}}
                                </div>
                            </div>
                        </div> -->

                        <div class="field col-12 md:col-2">
                            <label htmlFor="cropType">{{'CROP_TYPE'| translate}}</label>
                            <p-autoComplete [disabled]="!showInputfields" formControlName="cropType"
                                placeholder="Select Crop Type" id="cropType" [dropdown]="true" [multiple]="false"
                                [suggestions]="filteredCropType" (completeMethod)="filterCropType($event)" field="label"
                                value="" (ngModelChange)="getCropTypeName($event)"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.cropType.touched && finalEstimationControls.cropType.errors }">
                            </p-autoComplete>
                            <div *ngIf="finalEstimationControls.cropType.touched && finalEstimationControls.cropType.errors"
                                class="invalid-feedback">{{'CROP_TYPE_IS_REQ'| translate}}</div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="crop">{{'CROP'| translate}}</label>
                            <p-autoComplete [disabled]="!showInputfields" formControlName="crop"
                                placeholder="Select Crop" id="crop" [dropdown]="true" [multiple]="false"
                                [suggestions]="filteredCrop" (completeMethod)="filterCrop($event)" field="label"
                                value=""
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.crop.touched && finalEstimationControls.crop.errors }">
                            </p-autoComplete>
                            <div *ngIf="finalEstimationControls.crop.touched && finalEstimationControls.crop.errors"
                                class="invalid-feedback">{{'CROP_IS_REQ'| translate}}
                            </div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="discountRate">{{'DISCOUNT_RATE'| translate}}</label>
                            <input formControlName="discountRate" (ngModelChange)="onMIAreaChange()" pInputText
                                id="discountRate" type="number" min="0" max="100" />
                        </div>

                        <!-- <div class="field col-12 md:col-2">
                            <label htmlFor="taxRate">Tax Rate</label>
                            <input formControlName="taxRate" pInputText id="taxRate" type="number"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.taxRate.touched && finalEstimationControls.taxRate.errors }" />
                            <div *ngIf="finalEstimationControls.taxRate.touched && finalEstimationControls.taxRate.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.taxRate.errors.required">Tax Rate is required
                                </div>
                            </div>
                        </div> -->

                        <div class="field col-12 md:col-2">
                            <label htmlFor="MIArea">{{'MI_AREA'| translate}}</label>
                            <input formControlName="MIArea" pInputText id="taxRate" type="number"
                                (ngModelChange)="onMIAreaChange()"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.MIArea.touched && finalEstimationControls.MIArea.errors }" />
                            <div *ngIf="finalEstimationControls.MIArea.touched && finalEstimationControls.MIArea.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.MIArea.errors.required">{{'MI_AREA_IS_REQ'|
                                    translate}}
                                </div>
                                <div *ngIf="MIAreaCustomerror" class="error">{{'ON_INVALID_MI_AREA'| translate}}</div>
                            </div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="remarks">{{'REMARKS'| translate}}</label>
                            <input formControlName="remarks" pInputText id="remarks" type="text"
                                [ngClass]="{ 'ng-invalid ng-dirty': finalEstimationControls.remarks.touched && finalEstimationControls.remarks.errors }" />
                            <div *ngIf="finalEstimationControls.remarks.touched && finalEstimationControls.remarks.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.remarks.errors.required">{{'REMARKS_IS_REQ'|
                                    translate}}
                                </div>
                            </div>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="block">{{'LAND_MAP'| translate}}</label>
                            <div class="flex">
                                <p-fileUpload accept=".jpeg,.pdf,.jpg" #vendorLandMapPath [customUpload]="true"
                                    (uploadHandler)="onUpload($event, 'landMapPath', vendorLandMapPath)" name="myfile[]"
                                    mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}"
                                    [auto]="true">
                                </p-fileUpload>
                                <p-image *ngIf="finalEstimationControls.landMapPath.value"
                                    [src]="finalEstimationControls.landMapPath.value" alt="Image" width="60"
                                    class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

                            </div>
                            <div *ngIf="finalEstimationControls.landMapPath.touched && finalEstimationControls.landMapPath.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.landMapPath.errors.required">{{'LAND_MAP_IS_REQ'|
                                    translate}}
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="block">{{'SIGNATURE'| translate}}</label>
                            <div class="flex">
                                <p-fileUpload accept=".jpeg,.pdf,.jpg" #vendorSignature [customUpload]="true"
                                    (uploadHandler)="onUpload($event, 'signaturePath', vendorSignature)" name="myfile[]"
                                    mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}"
                                    [auto]="true">
                                </p-fileUpload>
                                <p-image *ngIf="finalEstimationControls.signaturePath.value"
                                    [src]="finalEstimationControls.signaturePath.value" alt="Image" width="60"
                                    class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

                            </div>
                            <div *ngIf="finalEstimationControls.signaturePath.touched && finalEstimationControls.signaturePath.errors"
                                class="invalid-feedback">
                                <div *ngIf="finalEstimationControls.signaturePath.errors.required">{{'SIGNATURE_IS_REQ'|
                                    translate}}
                                </div>
                            </div>
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-12 md:col-2">
                            <label htmlFor="componentTotal">{{'COMPONENT_TOTAL'| translate}} :</label>
                            <p><label>{{'RS.'| translate}} {{estimatedComponentTotal -
                                    (estimatedComponentTotal*finalEstimationDetails.value.discountRate)/100 | number :
                                    '1.2-2'}}/-</label></p>
                        </div>

                        <!-- <div class="field col-12 md:col-2">
                            <label htmlFor="gstTotal">GST Total :</label>
                            <p><label>Rs. {{estimatedGSTTotal -
                                    (estimatedGSTTotal*finalEstimationDetails.value.discountRate)/100| number :
                                    '1.2-2'}}/-</label></p>
                        </div> -->

                        <div class="field col-12 md:col-2">
                            <label htmlFor="transportCharge">{{'TRANSPORT_OTHER_CHARGES'| translate}} :</label>
                            <p><label>{{'RS.'| translate}} {{isTransportFree? 00 : (2500 *
                                    finalEstimationDetails.value.MIArea | number :
                                    '1.2-2') }}/-</label>
                            </p>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="grandTotal">{{'GRAND_TOTAL'| translate}} :</label>
                            <p><label>{{'RS.'| translate}} {{grandTotal| number :
                                    '1.2-2'}}/-</label></p>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="subsidyAmount">{{'SUBSIDY_AMOUNT'| translate}} :</label>
                            <p><label>{{'RS.'| translate}} {{((grandTotal * 85)/100) |
                                    number: "1.2-2"}}/-</label>
                            </p>
                            <!-- <p><label>Rs. {{(((isTransportFree ? 00 : 2500 * finalEstimationDetails.value.MIArea) +
                                    ((estimatedGrandTotal - estimatedGSTTotal)  - estimatedGrandTotal*finalEstimationDetails.value.discountRate/100)) *85) /100 |
                                    number: "1.2-2"}}/-</label>
                            </p> -->
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="farmerShare">{{'FARMER_SHARE'| translate}} :</label>
                            <p><label>{{'RS.'| translate}} {{((grandTotal * 15)/100)|
                                    number: "1.2-2"}}/-</label>
                            </p>
                            <!-- <p><label>Rs. {{(((isTransportFree ? 00 : 2500 * finalEstimationDetails.value.MIArea) +
                                    ((estimatedGrandTotal - estimatedGSTTotal)  - estimatedGrandTotal*finalEstimationDetails.value.discountRate/100)) *15) /100 |
                                    number: "1.2-2"}}/-</label>
                            </p> -->
                        </div>

                        <div class="field col-12 md:col-2">
                            <!-- pro data calculations -->
                            <div class="mt-2 proDataButton">
                                <button (click)="proDataCalculation()" pButton pRipple type="submit"
                                    label="{{'VIEW_MAX_ELIGIBLE_SUBSIDY_AS_PER_UNIT_COST'| translate}}"
                                    class="p-button-info mr-2 mb-2"></button>
                            </div>
                            <div *ngIf="showProDataCalError" class="invalid-feedback mb-2">
                                <div *ngIf="finalEstimationControls?.rowSpacing?.errors?.required">
                                    {{'ON_INVALID_ROW_SPACING'| translate}}
                                </div>
                                <div *ngIf="finalEstimationControls?.plantSpacing?.errors?.required">
                                    {{'ON_INVALID_PLANT_SPACING'| translate}}
                                </div>
                                <div *ngIf="finalEstimationControls?.MIArea?.errors?.required">
                                    {{'MI_AREA_SPACING_IS_REQ'| translate}}
                                </div>
                            </div>
                        </div>

                    </div>



                    <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData">
                        <div class="field col-12 md:col-3">
                            <label htmlFor="pro-data">{{'PRO_DATA_MAX_SUBSIDY_FORMULA'| translate}}:</label>
                            <p><label>{{ proCalculatedData.Formula }}</label></p>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="output">{{'OUTPUT'| translate}}:</label>
                            <p><label>{{ proCalculatedData.Output }}</label></p>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="amount">{{'AMOUNT'| translate}}:</label>
                            <p><label>{{'RS.'| translate}} {{ proCalculatedData.Amount }}/-</label></p>
                        </div>

                        <div class="field col-12 md:col-1">
                            <label htmlFor="maxSubsidy">{{'MAX_SUBSIDY'| translate}}:</label>
                            <p><label>{{'RS.'| translate}} {{ proCalculatedData.maxSubsidy }}/-</label></p>
                        </div>

                        <div class="field col-12 md:col-1">
                            <label htmlFor="transportAmount">{{'TRANSPORT_AMOUNT'| translate}}:</label>
                            <p><label>{{'RS.'| translate}} {{ proCalculatedData.TransportAmount }}/-</label></p>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="result">{{'RESULT'| translate}}:</label>
                            <p><label>{{ proCalculatedData.Result }}</label></p>
                        </div>

                    </div>

                    <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData-new">
                        <div class="field col-12 md:col-3">
                            <label htmlFor="pro-data">{{'PRO_DATA_MAX_SUBSIDY_FORMULA_NEW'| translate}}:</label>
                            <p><label>{{ proCalculatedData.FormulaNewCalc }}</label></p>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="output">{{'OUTPUT_NEW'| translate}}:</label>
                            <p><label>{{ proCalculatedData.OutputNewCalc }}</label></p>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="amount">{{'AMOUNT_NEW'| translate}}:</label>
                            <p><label>{{'RS.'| translate}} {{ proCalculatedData.AmountNewCalc }}/-</label></p>
                        </div>

                        <div class="field col-12 md:col-1">
                            <label htmlFor="maxSubsidy">{{'MAX_SUBSIDY_NEW'| translate}}:</label>
                            <p><label>{{'RS.'| translate}} {{ proCalculatedData.maxSubsidyNewCalc }}/-</label></p>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="result">{{'RESULT_NEW'| translate}}:</label>
                            <p><label>{{ proCalculatedData.ResultNewCalc }}</label></p>
                        </div>

                    </div>

                    <button *ngIf="isUpdateClicked" (click)="submitFinalEstimationUpdated()" pButton pRipple
                        type="submit" label="{{'UPDATE'| translate}}" class="p-button-success mr-2 mb-2"
                        [disabled]="finalEstimationDetails.invalid || !isProDataCalculated"></button>
                    <button *ngIf="!isUpdateClicked" (click)="submitFinalEstimation()" pButton pRipple type="submit"
                        label="{{'SUBMIT'| translate}}" class="p-button-success mr-2 mb-2"
                        [disabled]="finalEstimationDetails.invalid || !isProDataCalculated"></button>
                    <button (click)="cancelFinalEstimation()" pButton pRipple type="button"
                        label="{{'CANCEL'| translate}}" class="p-button-danger mr-2 mb-2"></button>
                </form>
            </div>
        </div>
        <!-- Final Estimation Details End -->
    </div>
    <!-- Content End-->
</p-dialog>